import { render, staticRenderFns } from "./settings-fill.vue?vue&type=template&id=67afe1b0&scoped=true&"
import script from "./settings-fill.vue?vue&type=script&lang=js&"
export * from "./settings-fill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67afe1b0",
  null
  
)

export default component.exports